import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAuthStore } from "@/store";
/**
 * 레이아웃에서 사용되는 훅
 *
 * @returns
 */
export default function useLayout() {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState<boolean>(false);
  const [isClose, setIsClose] = useState<boolean>(false);

  // 🔥 zustand authStore에서 사용자 정보 가져오기
  const { user } = useAuthStore();
  const username = user?.admNm || "관리자";

  const container =
    window !== undefined ? () => window.document.body : undefined;

  const handleDrawerToggle = () => {
    if (!isClose) {
      setMobileOpen(!mobileOpen);
    }
  };

  const handleDrawerTransitionEnd = () => {
    setIsClose(false);
  };

  const handleDrawerClose = () => {
    setIsClose(true);
    setMobileOpen(false);
  };

  useEffect(() => {
    // location 변경 시 필요한 로직이 있다면 여기에 추가
  }, [location]);

  return {
    username,
    mobileOpen,
    handleDrawerToggle,
    handleDrawerTransitionEnd,
    handleDrawerClose,
    container,
  };
}
